<template>
  <b-card>
    <b-modal
      id="driver-health-modal"
      centered
      title="Driver Health"
      hide-footer
      @shown="driverHealthModalShown"
    >
      <b-spinner
        v-if="fetchingHealth"
        variant="primary"
      />
      <div v-else>
        <div v-if="driverDashboardHealthData && Object.keys(driverDashboardHealthData).length">
          <b-list-group>
            <b-list-group-item
              v-for="(value, key) in driverDashboardHealthData"
              :key="key"
              class="d-flex justify-content-between align-items-center"
            >
              <strong>{{ key }}</strong>
              <span>{{ value }}</span>
            </b-list-group-item>
          </b-list-group>
        </div>
        <div v-else>
          <p>No health data available.</p>
        </div>
      </div>
    </b-modal>
    <AssignViolationModal :driver-id="trip.driver_details.id" />
    <b-card-title class="d-flex justify-content-between align-items-center">
      <h4 class="text-center">
        Driver
      </h4>
      <b-button
        variant="outline-primary"
        size="sm"
        @click="$bvModal.show('driver-health-modal')"
      >
        Driver Health
      </b-button>
      <div class="d-flex ">
        <b-button
          :disabled="!trip.driver_details.id"
          class="btn-icon rounded-circle"
          variant="flat-primary"
          @click="$bvModal.show('assign-violation')"
        >
          <feather-icon
            icon="WindIcon"
          />
        </b-button>
        <b-button
          :disabled="!trip.driver_details.id"
          class="btn-icon rounded-circle"
          variant="flat-primary"
          @click="$router.push({
            path: `/drivers/${trip.driver_details.id}?externalId=${trip.driver_details.external_id}`
          })"
        >
          <feather-icon
            icon="UserIcon"
          />
        </b-button>
        <b-button
          :disabled="!trip.driver_details.id"
          class="btn-icon rounded-circle"
          variant="flat-primary"
          @click="$router.push({
            path: `/drivers/${trip.driver_details.id}?externalId=${trip.driver_details.external_id}`,
            query: { 'active-tab' :'wallet' }
          })"
        >
          <feather-icon
            icon="BriefcaseIcon"
          />
        </b-button>
      </div>
    </b-card-title>
    <template v-if="performanceData">
      <b-row>
        <b-col
          md="6"
          class="d-flex align-items-center"
        >
          <div class="d-flex align-items-center">
            <span class="font-weight-bold mr-1">Joined Days:</span>
            {{ performanceData.joined_days }}
          </div>
        </b-col>
        <b-col
          md="6"
          class="d-flex align-items-center"
        >
          <div class="d-flex align-items-center">
            <span class="font-weight-bold mr-1">Completed Trips:</span>
            {{ performanceData.no_all_completed_trips }}
          </div>
        </b-col>
        <b-col
          md="12"
          class="d-flex align-items-center"
        >
          <div class="d-flex align-items-center">
            <span class="font-weight-bold mr-1">Frequency:</span>
            {{ performanceData.frequency }}
          </div>
        </b-col>
      </b-row>
    </template>
    <hr>
    <!--  -->
    <b-row
      v-if="trip"
    >
      <b-col
        v-for="(item, idx) in pickFrom"
        :key="idx"
        md="12"
        class="mb-1"
      >
        <span class="font-weight-bold">{{ item.label }}: </span> {{ item.key(trip.driver_details) ? item.key(trip.driver_details) : '_' }}
      </b-col>
      <b-col
        md="12"
        class="mt-2 mb-1"
      >
        <h3>Car Details</h3>
      </b-col>
      <b-col
        md="8"
        class="mb-2"
      >
        <strong>Car Number: </strong> {{ trip.driver_details.car.car_number && trip.driver_details.car.car_number }}
      </b-col>
      <b-col md="4">
        <strong>Color: </strong> {{ trip.driver_details.car.color && trip.driver_details.car.color }}
      </b-col>
      <b-col md="4">
        <strong>Make: </strong> {{ trip.driver_details.car.make && trip.driver_details.car.make }}
      </b-col>
      <b-col md="4">
        <strong>Model: </strong> {{ trip.driver_details.car.model && trip.driver_details.car.model }}
      </b-col>
      <b-col md="4">
        <strong>Year: </strong> {{ trip.driver_details.car.year && trip.driver_details.car.year }}
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle, BRow, BCol, BButton, BModal,
  BSpinner,
  BListGroup,
  BListGroupItem,
} from 'bootstrap-vue'
import { inject, ref } from '@vue/composition-api'
import axiosIns from '@/libs/axios'
import AssignViolationModal from '@/views/driver/drivers-view/tabs/violations/AssignViolationModal.vue'

export default {
  components: {
    BCard,
    BCardTitle,
    BRow,
    AssignViolationModal,
    BCol,
    BButton,
    BSpinner,
    BModal,
    BListGroup,
    BListGroupItem,
  },
  setup() {
    const pickFrom = [
      {
        key: el => el?.first_name + " " + el?.last_name,
        label: 'Name',
      },
      {
        key: el => el?.phone_number,
        label: 'Phone Number',
      },
      {
        key: el => el?.driver_id,
        label: 'Number',
      },
      {
        key: el => el?.rating,
        label: 'Rating',
      },

    ]
    const trip = inject('trip')

    const performanceData = ref()
    const fetchDriverHealth = async () => {
      const res = await axiosIns.get('/trips/performance/segmentation', {
        params: {
          external_id: trip.value.driver_details.external_id,
          type: 'driver',
        },
      })
      performanceData.value = res.data.data
    }
    if (Object.keys(trip.value.driver_details).length) {
      fetchDriverHealth()
    }

    console.log(trip.value)
    const driverDashboardHealthData = ref({})
    const fetchingHealth = ref(false)
    const fetchDriverDashboardHealth = async () => {
      fetchingHealth.value = true
      try {
        const res = await axiosIns.get('/users/dashboard-health', {
          params: {
            userId: trip.value?.driver_details?.id,
            dashboardType: 'Driver-Health',
          },
        })
        const { data } = res.data
        driverDashboardHealthData.value = data
      } finally {
        fetchingHealth.value = false
      }
    }

    const driverHealthModalShown = () => {
      fetchDriverDashboardHealth()
    }

    return {
      driverHealthModalShown,
      driverDashboardHealthData,
      fetchDriverDashboardHealth,
      trip,
      fetchingHealth,
      performanceData,
      pickFrom,
    }
  },
}
</script>

<style scoped>
.driver-info__no-driver {
    height: 60%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
